<template>
    <div
        class="flex-nowrap"
        v-bind:class="{ 'input-group': showAgency }">
        <span
            v-if="showAgency"
            class="input-group-text">
            {{ $app.ProgramInfo.AgencyDisplayName }}
        </span>
        <div v-bind:class="{ show: showDropdown }">
            <button
                ref="programsButton"
                class="btn btn-outline-primary h-100 w-100 dropdown-toggle"
                data-test-role="programsButton"
                v-bind:style="dropDownButtonStyleObj"
                v-on:click="toggleDropdown">
                {{ programText }}
            </button>
            <nav-programs-dropdown
                ref="navProgramsDropdown"
                class="dropdown-menu border-0 pb-0"
                v-bind:class="{ show: showDropdown }"
                v-on:popper-opened="showDropdown = true"
                v-on:popper-closed="showDropdown = false" />
        </div>
    </div>
</template>

<script>
    import navProgramsDropdown from "./navProgramsDropdown.vue";
    import { KEYS, NAMESPACE } from "./i18n/navHeader.i18n";

    export default {
        components: {
            navProgramsDropdown
        },
        props: {
            collapseLevel: { type: Number, required: true }
        },
        data() {
            return {
                showDropdown: false
            };
        },
        computed: {
            showAgency() {
                return this.collapseLevel <= 0;
            },
            programText() {
                if (this.collapseLevel <= 1) {
                    return this.$app.ProgramInfo.DisplayName;
                }
                return this.$app.res({
                    namespace: NAMESPACE,
                    key: KEYS.programsButtonLabel
                });
            },
            dropDownButtonStyleObj() {
                // This gets set in the base stylesheet conditioned on $enable-rounded. If rounded is enabled,
                // keep the left two corners square so that it looks more natural next to the agency name span.
                const inputBorderRadius = window
                    .getComputedStyle(document.body)
                    .getPropertyValue("--pc-input-border-radius");
                return inputBorderRadius === "0px"
                    ? {}
                    : {
                          "border-radius": this.showAgency
                              ? "0 var(--bs-border-radius) var(--bs-border-radius) 0"
                              : "var(--bs-border-radius)"
                      };
            }
        },
        methods: {
            toggleDropdown() {
                this.$refs.navProgramsDropdown.popper_toggle(this.$refs.programsButton);
            }
        }
    };
</script>
